import { Typography } from '@mui/material';

import { CustomTextArea } from '@/shared/components/ui';
import { CustomConfirmDialogProps } from '@/shared/components/ui/Dialogs';

export type ConfirmUpdFotosAlertActivacionFotosModalProps = {
  isOpenConfirmDialog: boolean;
  setIsOpenConfirmDialog: (open: boolean) => void;
  form: any;
  handleConfirm: Function;
  confirmTextBtn?: string;
  isSalida?: boolean;
};

const ConfirmUpdFotosAlertActivacionFotosModal: React.FC<
  ConfirmUpdFotosAlertActivacionFotosModalProps
> = ({
  form,
  handleConfirm,
  isOpenConfirmDialog,
  setIsOpenConfirmDialog,
  confirmTextBtn = 'Solicitar',
  isSalida = false,
}) => {
  return (
    <>
      {/* ========= confirm dialog ========= */}
      <CustomConfirmDialogProps
        open={isOpenConfirmDialog}
        title={`Solicitar Actualización de Fotos de ${
          isSalida ? 'Salida' : 'Ingreso'
        }`}
        contentNode={
          <>
            <Typography variant="body1">
              Para solicitar la actualización de las fotos de{' '}
              {isSalida ? 'salida' : 'ingreso'} es necesario ingresar una
              observación del motivo de la solicitud.
            </Typography>

            <CustomTextArea
              label="Observación"
              name="comentario_solicita_upd_fotos"
              control={form.control}
              defaultValue={
                form.getValues('comentario_solicita_upd_fotos') || ''
              }
              error={form.formState.errors.comentario_solicita_upd_fotos}
              helperText={
                form.formState.errors.comentario_solicita_upd_fotos?.message
              }
              required={false}
              sxTextField={{
                mt: 3,
              }}
            />
          </>
        }
        // actions
        confirmTextBtn={confirmTextBtn}
        onConfirm={form.handleSubmit(handleConfirm, () => {})}
        onClose={() => {
          setIsOpenConfirmDialog(false);
        }}
      />
    </>
  );
};

export default ConfirmUpdFotosAlertActivacionFotosModal;
